import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { AmcLambdaFetch, awaitJSON } from '@src/utils/fetch-utils';
import { AudiencePenetrationData } from '../audience-penetration-types';

const fetchAudiencePenetrationData = async (
  amcInstanceId: string,
  reportEndDate?: string
): Promise<AudiencePenetrationData> => {
  const response = await AmcLambdaFetch('/getAudiencePenetrationReport', {
    params: { amcInstanceId, ...(reportEndDate ? { reportEndDate } : {}) }
  });
  return awaitJSON<AudiencePenetrationData>(response);
};

export const useAudiencePenetrationData = (
  amcInstanceId: string | undefined,
  reportEndDate?: string
): ReturnType<typeof useQuery<AudiencePenetrationData>> =>
  useQuery({
    meta: { suppressGlobalError: true },
    queryKey: ['audiencePenetrationData', amcInstanceId, reportEndDate],
    queryFn: () => {
      if (!amcInstanceId) throw new Error('Missing AMC instance id');
      return fetchAudiencePenetrationData(amcInstanceId, reportEndDate);
    },
    enabled: Boolean(amcInstanceId),
    // Keep the prior period's data on screen while a newly-selected period loads, so the
    // period picker and dashboard don't flash out.
    placeholderData: keepPreviousData
  });
